import './benchpowersupply.css'
import '../projectscontent.css'

import { GlowingText2em } from "../../../../components/glowingtextcomponet/glowingtext2em.js";
import { GlowingText1em } from "../../../../components/glowingtextcomponet/glowingtext1em.js";
import { Gallery } from "../../../../components/gallery/gallery.js";

// material images
import image1 from "./materialimages/atxpowersupply.png";
import image2 from "./materialimages/LM2577SLM2596S.png";
import image3 from "./materialimages/digitalvoltmeterammeter.png";
import image4 from "./materialimages/10W47R.png";
import image5 from "./materialimages/rockerswitch.png";
import image6 from "./materialimages/multiturnpotentiometer.png";
import image7 from "./materialimages/ledgreenred.png";
import image8 from "./materialimages/femaleusb.png";
import image9 from "./materialimages/bulletterminal.png";
import image10 from "./materialimages/1-4W220R.png";

import layout from "./methodologyimages/makinglayout.jpg";
import eletricscheme from "./methodologyimages/eletricscheme.png";
import configuringwires1 from './methodologyimages/configuringwires1.jpg';
import configuringwires2 from './methodologyimages/configuringwires2.jpg';
import configuringwires3 from './methodologyimages/configuringwires3.jpg';
import mounting1 from './methodologyimages/mounting1.jpg';
import mounting2 from './methodologyimages/mounting2.jpg';
import mounting3 from './methodologyimages/mounting3.jpg';
import stepupdown from './methodologyimages/stepupdown.png';

import resultimage1 from "./resultimages/result1.jpg";
import resultimage2 from "./resultimages/result2.jpg";

const materialImages = [
    { file: image1, description: 'ATX Power Supply' },
    { file: image2, description: 'Module Step Up Down LM2577S LM2596S' },
    { file: image3, description: 'Digital Voltmeter Ammeter' },
    { file: image4, description: 'Resistor 47 Ohms 10 Watts' },
    { file: image5, description: 'Rocker Switch' },
    { file: image6, description: 'Multiturn Potentiometer' },
    { file: image7, description: '1 Led Green 1 Led Red' },
    { file: image8, description: 'Dual Female USB' },
    { file: image9, description: 'Bullet Terminal' },
    { file: image10, description: '2x Resistor 220 Ohms 1/4 Watt' },
];

const configuringWiresImages = [
    { file: configuringwires1, description: 'Configuring Wires' },
    { file: configuringwires2, description: 'Configuring Wires' },
    { file: configuringwires3, description: 'Configuring Wires' },
];

const mountingImages = [
    { file: mounting1, description: 'Assembling Components' },
    { file: mounting2, description: 'Assembling Components' },
    { file: mounting3, description: 'Assembling Components' },
];

const resultImages = [
    { file: resultimage1, description: 'Final Result' },
    { file: resultimage2, description: 'Final Result' },
];

export const BenchPowerSupply = () => (
    <div className='content'>

        <GlowingText2em content='Bench Power Supply'/>
        <p className='projecttext'>
            An adjustable source or adjustable source is an electronic equipment in which you can adjust both the voltage and the output current to power / energize an electronic circuit or perform functionality tests. In order to adequately power components and equipment, adjustable power supplies transform electrical energy from the network in the form of alternating current (AC) into direct current (DC) electrical energy. Generally, the adjustable source is used on tables or work benches, they aim to assist in testing, repairing and recharging various electronic equipment, such as: cell phones, digital cameras, testing motors and lamps, recharging batteries, feeding electronic projects in Breadboards , carry out consumption tests and short identification, among other applications. An adjustable power supply is part of the essential and indispensable tools of a complete electronic workbench.
        </p>

        <div className="subtext">
            <GlowingText1em content='Materials Used'/>
        </div>

        <Gallery images={materialImages} alt="Material" />

        <div className="subtext">
            <GlowingText1em content='Methodology'/>
        </div>

        <p className='projecttext'>
            First, the ATX power supply was opened and a brush was used to remove the dust. A layout was set up in such a way that all the external components would fit in one of the side faces that was empty. Rectangular cuts were made by means of a grinder and circular shapes by means of a drill in order to fix the external components.
        </p>

        <img className='singleimage' src={layout} alt='Defining the layout and pinning the components'></img>
        <div className='singleimagedescription'>Defining The Layout And Pinning The Components</div>

        <p className='projecttext'>
            The electrical diagram made for the bench source was projected, which will be used as a reference for the assembly, as shown in the image below:
        </p>

        <img className='singleimage' src={eletricscheme} alt='Eletric scheme'/>
        <div className='singleimagedescription'>Bench Power Supply Eletrical Diagram</div>

        <div className='projecttext'>

            The wire colors of ATX power supplies have standards for their respective functions as shown in the list below.

            <ul className='wirecolorlist'>
                <li><p id='greentext'>Green</p> Power On</li>
                <li><p id='greytext'>Grey</p> Power Good (self-test OK)</li>
                <li><p id='purpletext'>Purple</p> +5v Standby</li>
                <li><p id='browtext'>Brown</p> +3.3V Sense (Not Necessary)</li>
                <li><p id='Yellowtext'>Yellow</p> +12 Volts</li>
                <li><p id='bluetext'>Blue</p> -12 Volts</li>
                <li><p id='redtext'>Red</p> +5 Volts</li>
                <li><p id='orangetext'>Orange</p>+3.3 Volts</li>
                <li><p id='blacktext'>Black</p> 0 Volts (Ground)</li>
            </ul>

            According to the wiring diagram, 2 red wires will be for the female USB connector, 1 red wire for the 47 ohm 10 watts resistor and 1 red wire for the ring terminal of the female bullet connector.
            1 orange wire to the ring terminal of the female bullet connector.
            The blue wire will be connected directly to the ring terminal of the female bullet connector.
            A yellow wire for powering the digital ammeter voltmeter, 1 for the ring terminal of the female bullet connector and the rest for the positive input of the step up down module.

        </div>

        <p className='projecttext'>
            Removed the brown wire as it is used for signal and will not be needed.
            Heat-shrink tubing was used to make wire organization easier. A multimeter was always used to test the functionality of the wires and components during assembly.
            The images below show the process of selecting and arranging the wires in order to obtain a good wire configuration.
         </p>

        <Gallery images={configuringWiresImages} alt="Configuring wires" />

        <div className='projecttext'>

            The steps described below were followed for the internal assembly of the source.
            <ol className='wirecolorlist'>
                <li>
                    Solder the green wire to one pin of the rocker switch and a black wire to the other pin. It was tested whether the source turn on correctly through the rocker switch.
                </li>
                <li>
                    The 220 ohm resistor was soldered to the positive pole of the red LED. As the LED is a polarized component, a black wire was soldered to the negative pole of the LED and the purple wire was soldered to the resistor. It was tested by checking whether the red LED lights up when connecting the source to the electrical power phase.
                </li>
                <li>
                    The 220 ohm resistor was soldered to the positive pole of the green LED. Subsequently, a black wire was soldered to the negative pole and the gray wire was soldered to the resistor. It was tested by checking whether the green led lit up when turning on the power supply through the rocker switch described in item 1.
                </li>
                <li>
                    A yellow, red, orange, blue and 2 black wires were soldered respectively to each terminal ring of the female bullet connector. A multimeter was used to verify that the voltages of the wires are correct according to the list of wire colors.
                </li>
                <li>
                    The red wires were soldered to the positive pin and the black ones to the negative pin of the female USB connector. Check whether the voltages were correct using a multimeter.
                </li>
                <li>
                    A red and a black wire were soldered to the 47 ohm 10 watt resistor. Hot glue was used to fix the resistor inside the source.
                </li>
                <li>
                    The voltmeter terminal of the digital ammeter voltmeter was soldered to a ring terminal of the female bullet connector. It corresponds to the source's positive terminal.
                </li>
                <li>
                    The ammeter terminal was soldered to the digital ammeter voltmeter on another ring terminal of the female bullet connector. It corresponds to the source's negative terminal.
                </li>
                <li>
                    1 wire was soldered to each terminal of the 2 multiturn potentiometers. A green wire was used for the GND terminal, an orange wire for the signal terminal and a blue wire for the VCC terminal of the multiturn potentiometer.
                </li>
            </ol>

            The images below show the process of assembling the wires and electronic components to the source.

        </div>

        <Gallery images={mountingImages} alt="Mounting components" />

        <p className='projecttext'>
            For the last step, the potentiometer responsible for regulating the voltage and the potentiometer responsible for regulating the current, indicated in the image below, were removed.
        </p>

        <img className='singleimage' src={stepupdown} alt='Step Up Down'></img>
        <div className='singleimagedescription'> Step Up Down</div>

        <p className='projecttext'>
            Then, the multiturn potentiometers were soldered to the step up down module using the wires previously soldered to the potentiometers, as described in item 9 of the assembly list.
            Then the remaining black wires from the source were soldered to the negative input of the module and the remaining yellow wires from the source were soldered to the positive input of the module.
        </p>

        <p className='projecttext'>
            The negative output of the module was soldered to the return wire of the digital ammeter voltmeter and the positive output of the module was soldered together to the ring terminal that corresponds to the positive terminal of the source described in item 7 of the assembly list.
            It was verified that the voltage was correct on the digital ammeter voltmeter display by varying the potentiometer and measuring with a multimeter on the positive and negative external terminals described in item 7 and 8 of the assembly list.
            Finally, the step up down module was fixed with hot glue to the inside of the power source for better organization.
        </p>

        <div className="subtext">
            <GlowingText1em content='Results'/>
        </div>

        <p className='projecttext'>
            As a final result, a source adjustable from 1.4 volts to 24.5 volts was obtained. It has two USB connectors and 4 fixed terminals of -12v, 3.3v, 5v and 12v as shown in the image below.
        </p>

        <Gallery images={resultImages} imageStyle={{ width: '600px', height: '500px' }} alt="Final result" />

    </div>
);
